import ErrorTemplate from './ErrorTemplate'

export default function Error404(): JSX.Element {

    return <ErrorTemplate code={404} codeMsg='Error' message='Oops, página não encontrada!' />
}
